<template>
    <div class="wrapBox" style=" padding-left:4px;padding-right:8px;padding-top:8px;">
        <div class="myChartTitleWrap">
            <div class="myChartTitle">{{titleText}}</div>
        </div>
        <div id="myLastYearCountryTrade" :style="{width: '100%', height: '210px'}">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        props: ['mainPageData'],
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                titleText: '中国-中东欧17国双边贸易数据（截至'+ this.mainPageData.dataEnd +'）'
            }
        },
        mounted() {
            this.drawLine();
        },
        methods: {
            getCountry (data) {
                let countryList = [];
                for(var i=0; i<data.length; i++) {
                    if(data[i].value1) countryList.push(data[i].value1);
                }
                return countryList;
            },
            getValue (data) {
                let valueList = [];
                for(var i=0; i<data.length; i++) {
                    valueList.push(data[i].value);
                }
                return valueList;
            },
            drawLine() {

                // 基于准备好的dom，初始化echarts实例
                let myLastYearCountryTrade = this.$echarts.init(document.getElementById('myLastYearCountryTrade'))
                // 绘制图表
                myLastYearCountryTrade.setOption({
                    backgroundColor:"#21232c",
                    textStyle:{ color:'#5d6066'},
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: '5%',
                        right: '5%',
                        bottom: '5%',
                        top: '15%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: this.getCountry(this.mainPageData.tradeBetweenList),
                        axisLabel: {
                            show: true,
                            interval: '0',
                            rotate: 45,
                            textStyle: {
                            color: '#fff'
                            }
                        }
                    },
                    yAxis: {
                        // type: 'value',
                        // name: '进出口额(亿)',
                        show: true,
                        axisLine: {show:true},
                        axisTick: {show:false},
                        splitLine:{show:false},
                        axisLabel:{
                            show: true,
                            textStyle: {
                            color: '#fff'
                            }
                        },
                    },
                    series: [{
                        name: '进出口额(亿)',
                        type: 'bar',
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color:'#27c3a4'
                            }
                        },
                        stack: 'total',
                        data: this.getValue(this.mainPageData.tradeBetweenList)
                    }]
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/LastYearCountryTrade.vue